import { get, post } from "../request";

// 创建 businessCard schema
export const createSchemas = (params) =>
  post(`api/v1/businessCard/schema/create`, params);

// 查询 businessCard schema
export const querySchemas = (params) =>
  post(`api/v1/businessCard/schema/querySchemas`, params);

// 查询 businessCard schema
export const querySchemasByDid = (params) =>
  post(`api/v1/businessCard/schema/querySchemasByDidNew`, params);

// 查询 businessCard schema
export const createOthers = (params) =>
  post(`api/v1/vc/schema/createOthers`, params);

// 查询 businessCard schema
export const updateSchemas = (params) =>
  post(`api/v1/businessCard/schema/update`, params);

// 查询 businessCard schema 详情
export const querySchemasById = (params) =>
  get(`api/v1/businessCard/schema/getById/${params}`);

// 查询 VC Schemas
export const queryVCSchemasNew = (params) =>
  get(`api/v1/vc/schema/queryVCSchemasNew?issuer=${params}`);

// 查询 VC Schemas
export const queryVCSchemas = (params) =>
  get(`api/v1/vc/schema/queryVCSchemas?issuer=${params}`);

// 查询 VC Schemas by ID
export const getById = (params) => get(`api/v1/vc/schema/getById?id=${params}`);

// 查询 VC Schemas 模板
// 0:非所有，1：所有
export const querySingleVCSchemas = (params) =>
  get(`api/v1/vc/schema/querySingleVCSchemas/${params}/1`);
